import { Col, Row, Typography, message } from "antd";
import { Formik } from "formik";
import * as Yup from "yup";
import { Checkbox, Form, FormItem } from "formik-antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  FormikEmailInput,
  FormikPassword,
  FormikSubmitButton,
} from "../FormItems";
import ImageComponent from "../Utilities/ImageComponent";
import Feedback from "../Utilities/Feedback";
import { StyledLink, SocialButton } from "../styled-components/components";
import * as userReducer from "../Redux/User/reducer";
import constants from "../Redux/constants";
import { useGoogleLogin } from "react-google-login";
import { LoadingOutlined } from "@ant-design/icons";
import google from "../../images/google.svg";
import linkedIn from "../../images/linkedin.svg";
import { Helmet } from "react-helmet";

const initialValues = {
  email: "",
  password: "",
  rememberMe: false,
};

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required("Email is required"),
  password: Yup.string()
    .min(8, "Must be 8 characters")
    .required("Password is required"),
  rememberMe: Yup.bool().notRequired(),
});

const LoginForm = (props) => {
  const [loader, setLoader] = useState(false);
  const { getUserDetails } = props;
  const history = useHistory();
  const signUpPage = () => {
    history.push("/");
  };
  const forgotPasswordPage = () => {
    history.push("/forgot-password");
  };

  const fetchUserDetails = async () => {
    const { responseStatus } = await getUserDetails();
    if (responseStatus === constants.status.success) {
      const role = localStorage.getItem("role");
      if (role === constants.roles.client) {
        history.push("/client/home");
      }
      if (role === constants.roles.consultant) {
        history.push("/consultant/home");
      }
      if (role === constants.roles.admin) {
        history.push("/admin/home");
      }
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetchUserDetails();
    }
  });

  // direct login
  const login = async (loginDetails, actions) => {
    const responseStatusCode = await props.loginUser(loginDetails);
    if (responseStatusCode === constants.status.conflict) {
      actions.setErrors({ password: "Invalid Password" });
      actions.setSubmitting(false);
    } else if (responseStatusCode === constants.status.notFound) {
      actions.setErrors({ email: "No such user found!!" });
      actions.setSubmitting(false);
    }
  };
  // google log in
  const responseGoogle = async (res) => {
    const token = res.tokenObj.id_token;
    if (token) {
      setLoader(true);
      const { responseStatus } = await props.googleAuthentication(token);
      if (responseStatus === constants.status.unAuthorative) {
        message.warning("You are not registered with us");
        history.push("/");
      }
      if (localStorage.getItem("role") === constants.roles.client) {
        history.push("/client/home");
      }
      if (localStorage.getItem("role") === constants.roles.consultant) {
        history.push("/consultant/home");
      }
    }
  };
  // linked in log in
  useEffect(() => {
    const popupWindowURL = new URL(window.location.href);
    const code = popupWindowURL.searchParams.get("code");
    localStorage.setItem("code", code);
    window.close();
  }, []);
  const handleLinkedIn = async () => {
    const accessCode = localStorage.getItem("code");
    const role = "";
    if (accessCode) {
      setLoader(true);
      const { responseStatus } = await props.getLinkedInAcessToken(
        process.env.REACT_APP_LINKED_REDIRECT_LOGIN_URL,
        accessCode,
        role
      );
      if (responseStatus === constants.status.unAuthorative) {
        setLoader(false);
        message.error("No User Found", 4);
        history.push("/");
      } else {
        if (localStorage.getItem("role") === constants.roles.client) {
          history.push("/client/home");
        }
        if (localStorage.getItem("role") === constants.roles.consultant) {
          history.push("/consultant/home");
        }
      }
    }
  };
  useEffect(() => {
    window.addEventListener("storage", handleLinkedIn);
    return () => {
      window.removeEventListener("storage", handleLinkedIn);
    };
  });
  const responseLinkedIn = async () => {
    const oauthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKED_IN_CLIENT_ID}&scope=r_liteprofile%20r_emailaddress&state=123456&redirect_uri=${process.env.REACT_APP_LINKED_REDIRECT_LOGIN_URL}`;
    const width = 450,
      height = 730,
      left = window.screen.width / 2 - width / 2,
      top = window.screen.height / 2 - height / 2;

    window.open(
      oauthUrl,
      "Linkedin",
      "menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=" +
        width +
        ", height=" +
        height +
        ", top=" +
        top +
        ", left=" +
        left
    );
  };
  return (
    <Col xs={{ span: 24 }} style={{ overflowX: "hidden" }}>
      <Helmet title="Login | Unicon" />
      <Row>
        <ImageComponent height="100vh" />
        <Col
          xs={{ span: 24 }}
          md={{ span: 14 }}
          lg={{ span: 12 }}
          xl={{ span: 7 }}
          xxl={{ span: 6 }}
          style={{
            padding: "1vh",
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "16vh",
          }}
        >
          {loader ? (
            <Col>
              <Feedback
                icon={<LoadingOutlined />}
                title="Logging In"
              ></Feedback>
            </Col>
          ) : (
            <Col>
              <Row>
                <Typography.Title level={4}>Log In</Typography.Title>
              </Row>
              <Row>
                <Col xs={{ span: 24 }}>
                  <Formik
                    initialValues={initialValues}
                    validateOnMount
                    validationSchema={validationSchema}
                    onSubmit={login}
                  >
                    {(formik) => {
                      return (
                        <Form>
                          <Col xs={{ span: 24 }}>
                            <FormikEmailInput
                              name="email"
                              prefix={true}
                              width="426px"
                            />
                          </Col>
                          <Col xs={{ span: 24 }}>
                            <FormikPassword name="password" suffix={true} />
                          </Col>
                          <Row justify="space-between">
                            <Col xs={{ span: 11 }}>
                              <FormItem name="rememberMe">
                                <Checkbox
                                  name="rememberMe"
                                  data-testid="rememberMe"
                                >
                                  Remember Me
                                </Checkbox>
                              </FormItem>
                            </Col>
                            <Col style={{ marginTop: "2px" }}>
                              <StyledLink
                                data-testid="submit-forgotPassword"
                                onClick={forgotPasswordPage}
                              >
                                Forgot Password?
                              </StyledLink>
                            </Col>
                          </Row>
                          <Col xs={{ span: 24 }}>
                            <FormikSubmitButton
                              id="submit-login"
                              disabled={!formik.isValid}
                              name="Log In"
                            ></FormikSubmitButton>
                          </Col>
                          <Row
                            justify="space-between"
                            style={{ marginTop: "2vh" }}
                          >
                            <Col>
                              <GoogleLogInButton
                                clientId={process.env.REACT_APP_GOOGLE_SIGN_UP}
                                onSuccess={responseGoogle}
                                onFailure={responseGoogle}
                              ></GoogleLogInButton>
                            </Col>
                            <Col>
                              <LinkedInButton
                                responseLinkedIn={responseLinkedIn}
                              ></LinkedInButton>
                            </Col>
                          </Row>

                          <Col style={{ marginTop: "2vh" }}>
                            New User?{" "}
                            <StyledLink
                              onClick={signUpPage}
                              data-testid="submit-signup"
                            >
                              Create Account
                            </StyledLink>
                          </Col>
                        </Form>
                      );
                    }}
                  </Formik>
                </Col>
              </Row>
            </Col>
          )}
        </Col>
      </Row>
    </Col>
  );
};

const GoogleLogInButton = (props) => {
  const { signIn } = useGoogleLogin({
    onSuccess: props.onSuccess,
    onFailure: props.onFailure,
    clientId: props.clientId,
  });
  return (
    <SocialButton onClick={signIn} data-testid="google-submit-login">
      <img src={google} height="30px" alt="google-login"></img>
      Sign In with Google
    </SocialButton>
  );
};

const LinkedInButton = (props) => {
  return (
    <SocialButton
      onClick={props.responseLinkedIn}
      data-testid="linkedin-submit-login"
    >
      <img src={linkedIn} height="30px" alt="linkedin-login"></img>
      Sign In with Linkedin
    </SocialButton>
  );
};

const mapToReducer = (dispatch) => {
  return {
    loginUser: (loginDetails) => dispatch(userReducer.loginUser(loginDetails)),
    getUserDetails: () => dispatch(userReducer.getUserDetails()),
    googleAuthentication: (token) =>
      dispatch(userReducer.googleAuthentication(token)),
    getLinkedInAcessToken: (redirectUri, accessCode, role) =>
      dispatch(
        userReducer.getLinkedInAcessToken(redirectUri, accessCode, role)
      ),
  };
};

export default connect(null, mapToReducer)(LoginForm);

// 2. add pagination for notifications

// 3. Upload File for comments
